import { getState } from "../state/store"
import { selectAppFieldsAccess, selectAppModulesAccess } from "../state/selectors/app"

const getAppModuleAccess = (moduleName) => {
    const modulesAccess = selectAppModulesAccess()(getState());

    if(moduleName && moduleName !== ''){
        const access = modulesAccess[moduleName];
        return access ? access : 0;
    }
    
    return 0;
}

const getAppFieldAccess = (fieldName) => {
    const fieldsAccess = selectAppFieldsAccess()(getState());

    if(fieldName && fieldName !== ''){
        const access = fieldsAccess[fieldName];
        return access ? parseInt(access) : 0;
    }

    return 0;
}

const hasFieldAccess = (fieldName, access) => {
    if(access && fieldName){
        const fieldAccess = getAppFieldAccess(fieldName);
        const acc = parseInt(access);
        return fieldAccess >= acc;
    }

    return true;
}

const hasModuleAccess = (moduleName, access) => {
    if(access && moduleName){
        const moduleAccess = getAppModuleAccess(moduleName);
        const acc = parseInt(access);
        return moduleAccess >= acc;
    }

    return true;
}

export {hasFieldAccess, hasModuleAccess};